import { URLS } from '../../constants';
import apiClient from '../client';

const saveClientDocument = {
  saveDocument: ({
    id,
    name,
    description,
    type,
    programBookUUID,
    modifiedBy,
    createdBy,
    intakeLocation,
    isUserCreated,
    quickDocumentName,
  }: {
    id: any;
    programBookUUID: any;
    name: any;
    description: any;
    createdBy: any;
    modifiedBy: any;
    intakeLocation: any;
    isUserCreated: any;
    type: any;
    quickDocumentName: any;
  }) =>
    apiClient.post(URLS.saveDocument, {
      data: {
        id,
        name,
        type,
        description,
        programBookUUID,
        createdBy,
        modifiedBy,
        intakeLocation,
        isUserCreated,
        quickDocumentName,
      },
    }),
};

export default saveClientDocument;
